export default __webpack_public_path__ + "static/media/Moon.ff9feb15.svg";